import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { CsiDownloadPaymentScheduleCSV } from '../../models/csi-download-payment-schedule-csv.model';
import { CsiMilestone2PaymentBatchDetails } from '../../models/csi-milestone2-payment-batch-details.model';
import { CsiMilestone2PercentageBasedActivity } from '../../models/csi-milestone2-percentage-based-activity.model';
import { CsiPaymentBatchList } from '../../models/csi-payment-batch-list.model';
import { CsiPaymentBatchMilestone2 } from '../../models/csi-payment-batch-milestone2.model';
import { CsiPaymentScheduleActivitiesM2 } from '../../models/csi-payment-schedule-activities-m2.model';
import { PaymentBatchStatusM2 } from '../../models/payment-batch-status-m2.model';
import { SettingsService } from '../common/settings.service';
import { EventsApiBase } from '../mcap-events/api-base';

@Injectable({
  providedIn: 'root'
})
export class CSIPaymentScheduleService extends EventsApiBase {
  constructor(
    http: HttpClient,
    public settings: SettingsService
  ) {
    super(http, settings);
  }

  getAllCsiM1PaymentBatch(): Observable<CsiPaymentBatchList[]> {
    return this.get<CsiPaymentBatchList[]>(
      'api/CSIPaymentSchedule/GetAllCSI_M1PaymentBatch',
      {}
    ) as Observable<CsiPaymentBatchList[]>;
  }
  getAllCsiM2PaymentBatch(): Observable<CsiPaymentBatchList[]> {
    return this.get<CsiPaymentBatchList[]>(
      'api/CSIPaymentSchedule/GetAllMilestone2PaymentBatches',
      {}
    ) as Observable<CsiPaymentBatchList[]>;
  }

  getMilestone2PaymentBatchStatus(): Observable<PaymentBatchStatusM2[]> {
    return this.get<PaymentBatchStatusM2[]>(
      'api/CSIPaymentSchedule/GetMilestone2PaymentBatchStatus',
      {}
    ) as Observable<PaymentBatchStatusM2[]>;
  }

  getMilestone2PaymentBatchActivities(
    pbName: string
  ): Observable<CsiMilestone2PaymentBatchDetails> {
    return this.get<CsiMilestone2PaymentBatchDetails>(
      'api/CSIPaymentSchedule/GetMilestone2PaymentBatchAndActivities/PaymentBatchName/' +
        pbName,
      {}
    ) as Observable<CsiMilestone2PaymentBatchDetails>;
  }

  GetMilestone2PaymentScheduleActivities(): Observable<
    CsiPaymentScheduleActivitiesM2[]
  > {
    return this.get<CsiPaymentScheduleActivitiesM2[]>(
      'api/CSIPaymentSchedule/GetMilestone2PaymentProgramFeedActivities',
      {}
    ) as Observable<CsiPaymentScheduleActivitiesM2[]>;
  }

  CreatePaymentBatchMilestone2(createpb: CsiPaymentBatchMilestone2) {
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/CSIPaymentSchedule/SubmitMilestone2PaymentBatch',
      createpb
    );
  }

  updateMilestone2PaymentBatch(editpb: CsiMilestone2PaymentBatchDetails) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/CSIPaymentSchedule/EditMilestone2PaymentBatch',
      editpb,
      { headers }
    );
  }

  ProcessCsiPaymentCap() {
    return this.http.post<any>(
      this.settings.baseEventsUrl + 'api/CSIPaymentSchedule/ProcessPaymentCap',
      null
    );
  }

  sendCsiCapLogicNotification(activityIds: number[]) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<boolean>(
      this.settings.baseEventsUrl +
        'api/CSINotifications/SendCapLogicNotifications',
      activityIds,
      { headers }
    );
  }

  getDownloadCSVFile(): Observable<CsiDownloadPaymentScheduleCSV[]> {
    return this.http.get<CsiDownloadPaymentScheduleCSV[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/ListofPaymentScheduleCsvFiles/ADD/'
    );
  }
  getDownloadCSVFileEdit(
    fileName: string
  ): Observable<CsiDownloadPaymentScheduleCSV[]> {
    return this.http.get<CsiDownloadPaymentScheduleCSV[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/ListofPaymentScheduleCsvFiles/EDIT/' +
        fileName
    );
  }

  downloadExportPoeCSV(selectedID: any[]) {
    const headers = new HttpHeaders();
    return this.http.post(
      this.settings.baseUrl + 'api/PoeInformation/DownloadPOESurveyDocs',
      selectedID,
      { headers, responseType: 'blob' }
    );
  }
  getMilestone2PaymentActivitiesExport(): Observable<
    CsiMilestone2PercentageBasedActivity[]
  > {
    return this.get<CsiMilestone2PercentageBasedActivity[]>(
      'api/CSIPaymentSchedule/GetCSIM2PercentageBasedActivityList',
      {}
    ) as Observable<CsiMilestone2PercentageBasedActivity[]>;
  }
}
